import React from 'react';
import about_image from '../../assets/images/Lucie-Skokanova.jpg';
import Headline from '../../partials/Headline';
import Text from '../../partials/Text';
import { Link } from 'react-router-dom';
import routes from '../../routes.json';

const HomepageAbout = () => {
  return (
    <div className="row homepage-about">
      <div className="container">
        <Headline h={3} className="headline-about">
          O mně
        </Headline>
        <div className="row">
          <div className="col">
            <Text >
              Jmenuji se Lucie Skokanová, jsem profesionální aromaterapeutka. 
              Od roku 2014 se věnuji aromaterapii ve své praxi, kde nabízím 
              různé druhy masáží, konzultací a aromaterapeutických výrobků 
              dle individuálních potřeb.
            </Text>
          </div>
          <div className="col">
            <img src={about_image} alt="Lucie Skokanová" className="about-image" />
          </div>
        </div>
        <div className="relative-wrap t-center">
          <Link to={routes.ABOUT} type="button" className="btn btn-default">
            Více o mně
          </Link>
        </div>
      </div>
    </div>
  )
}

export default HomepageAbout;